export const RENDER_SETTINGS_SITE_SCHEMA = [
  {
    key: 'resellers',
    icon: 'groups',
    children: [ 'resellers.domains' ]
  },

  {
    key: 'auth',
    icon: 'vpn_key',
    children: [ 'auth.registration.defaults' ]
  },

  {
    key: 'frontend',
    icon: 'color_lens',
    children: [
      'frontend.title',
      'frontend.colors',
      'frontend.documents.privacyPolicy',
      'frontend.documents.publicOffer',
      'frontend.jivosite'
    ]
  },

  {
    key: 'notifications',
    icon: 'notifications',
    children: [ { service: 'notifications.settingsSite' } ]
  },

  {
    key: 'payments',
    icon: 'payments',
    children: [ 'payments.methods' ]
  },

  {
    key: 'globalBlacklistManager',
    icon: '',
    children: [
      'globalBlacklistManager.mainListId',
      'globalBlacklistManager.temporaryAvailableListId'
    ]
  },

  {
    key: 'integrations',
    icon: 'extension',
    children: [ 'integrations.yclients.applicationCredentials' ]
  },

  {
    key: 'misc',
    icon: 'settings',
    children: [ 'misc.rootId' ]
  }
]

export const RENDER_SETTINGS_SITE_SCHEMA_RESELLER = [
  {
    key: 'auth',
    icon: 'vpn_key',
    children: [ 'auth.registration.defaults' ]
  },
  {
    key: 'frontend',
    icon: 'color_lens',
    children: [
      'frontend.title',
      { subtitle: 'frontend.colors' },
      'frontend.colors',
      { subtitle: 'frontend.documents' },
      'frontend.documents.privacyPolicy',
      'frontend.documents.publicOffer',
      { subtitle: 'frontend.jivosite' },
      'frontend.jivosite'
    ]
  },
  {
    key: 'notifications',
    icon: 'notifications',
    children: [ { service: 'notifications.settingsSite' } ]
  },
  {
    key: 'payments',
    icon: 'payments',
    children: [ 'payments.methods', 'payments.allowedGlobalMethods' ]
  }
]

export default {
  RENDER_SETTINGS_SITE_SCHEMA,
  RENDER_SETTINGS_SITE_SCHEMA_RESELLER
}
